import React from 'react';
import Spline from '@splinetool/react-spline';
import './style.css';

export default function Home() {
    return (
        <div className="hero-section">
            <div className="image-container">
                <img src="/images/wavesbackground.svg" alt="" className="bg-image" />
            </div>
            <div className="container">
                <div className="header">
                    <div className="logo">
                        <img src="./images/Logo.svg" alt="Logo" />
                    </div>
                    <div className="lets-talk-section">
                        <span>Let’s Talk</span>
                        <span>
              <img src="./images/Menu.svg" alt="Menu" />
            </span>
                    </div>
                </div>
                <div className="empires-image-section">
                    <div className="typography">
            <span>
              Where
              <p className="empires-typography">Empires</p>
              Are Born
            </span>
                        <div className="futurizing-typography">
                            Futurizing Infrastructure for Tomorrow’s AI Solutions.
                        </div>
                    </div>
                    <div className="helmet">
                        <Spline scene="https://prod.spline.design/DXL-H8clugkUmnLW/scene.splinecode" />
                    </div>
                </div>

            </div>
        </div>

    );
}
